<h1>Latest News</h1>
<div class="row row-cols-1 row-cols-md-2 row-cols-lg-1 g-4 mt-1">
  @for (newsItem of latestNews; track newsItem) {
    <div class="col-lg-4 col-md-6 col-sm-12">
      <div class="card mb-4 h-100">
        @if (newsItem.imageUrl) {
          <div>
            <img class="card-img-top"
              [src]="newsItem.imageUrl"
              alt="News Image"
              width="200"
              height="200" />
            </div>
          }
          <div class="card-body d-flex flex-column justify-content-between">
            <div class="">
              <h5 class="card-title">{{ newsItem.title }}</h5>
              <p class="card-text">{{ newsItem.description }}</p>
              @if (newsItem.publishDate) {
                <p class="date-color pt-2">
                  {{ newsItem.publishDate | date: 'short' }}
                </p>
              }
              @if (newsItem.tagSelections && newsItem.tagSelections.length > 0) {
                <div>
                  <p>Tags:</p>
                  <ul>
                    @for (tagSelection of newsItem.tagSelections; track tagSelection) {
                      <li>
                        {{ tagSelection.tagName }}
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
            <div class="d-flex justify-content-between">
              <i class="icon pointer-icon"
                [ngClass]="{'d-none': !configuration.editable}"
                (click)="edit(newsItem)">
                <fa-icon [icon]="faEdit"></fa-icon>
              </i>
              <i class="icon pointer-icon" (click)="confirmDelete(newsItem)">
                <fa-icon [icon]="faTrash"></fa-icon>
              </i>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="center mt-5 pb-5">
    <button type="button"
      class="btn btn-outline-primary"
      (click)="addLatestNews()"
      [attr.aria-expanded]="isCollapsed"
      aria-controls="collapseExample"
      aria-label="add">
      <fa-icon [icon]="faPlusSquare"></fa-icon>
    </button>
  </div>
  <div #collapse="ngbCollapse" [ngbCollapse]="!isCollapsed" (ngbCollapseChange)="isCollapsed = $event">
    <app-latest-news-form
      [latestNewsData]="latestNewsData"
      (refreshData)="getLatestNews()">
    </app-latest-news-form>
  </div>
